<template>
<v-dialog transition="dialog-bottom-transition" max-width="450" v-model="dialog" activator=".subscribeActivator" >
    <v-card class="tw-relative">
        <v-toolbar class="tw-font-sans tw-z-20" color="#282828" dark>
            Assinar Backstage
            <v-spacer />
            <a href="#" @click="dialog = false" class="tw-text-white"><i class="fas fa-times"></i></a>
        </v-toolbar>
        <v-card flat class="tw-rounded-none tw-overflow-y-auto" max-height="500">
            <v-img max-height="300" :src="options ? options.cover_img : artist.post_image ? artist.post_image : spotifyArtist.images[2].url" class="tw-border-b tw-border-white tw-border-opacity-10" gradient="to bottom, rgba(56,56,56,.81), rgba(30,30,30,1)">
                <v-card-title class="tw-justify-center tw-items-start tw-flex tw-flex-col tw-h-full tw-p-5">
                    <v-avatar size="85">
                        <img alt="user" :src="pageOptions.logo ? pageOptions.logo : (artist.post_image ? artist.post_image : spotifyArtist.images[2].url)">
                    </v-avatar>
                    <div class="tw-w-full tw-mt-8">
                        <p class="tw-text-white tw-font-sans tw-m-0 tw-text-sm tw-font-light">{{artist.artista_nome}}</p>
                        <p class="tw-text-white tw-font-sans tw-m-0 tw-text-2xl tw-font-medium">Seja membro desse backstage</p>
                        <p class="tw-text-white tw-font-sans tw-m-0 tw-text-sm tw-font-light">Tenha acesso a benefícios para assinantes</p>
                    </div>
                </v-card-title>
            </v-img>
            <div class="tw-p-5">
                <p class="tw-text-white tw-font-sans tw-mb-2 tw-text-xs tw-font-light">{{amount}}/ano</p>
                <v-btn @click="subscribe" class="waves-effect tw-rounded tw-px-5 tw-py-2 tw-from-purple-400 tw-to-purple-600 tw-bg-gradient-to-b tw-text-white tw-font-sans tw-text-xs tw-font-bold tw-uppercase tw-tracking-wide tw-leading-none"><i class="fas fa-key tw-mr-1"></i><span class="tw-leading-none">Assinar</span></v-btn>
                <p class="tw-text-white tw-font-sans tw-mb-2 tw-text-xs tw-font-light tw-opacity-50 tw-mt-1">O criador de conteúdo pode mudar os benefícios.</p>
            </div>
            <v-card-text class="tw-px-5 tw-pb-5 tw-pt-0" v-if="options.benefits_description ? options.benefits_description.length > 1 : false">
                <h3 class="tw-font-sans tw-text-white tw-font-medium">Benefícios</h3>      
                <p class="tw-font-sans tw-text-white tw-text-opacity-50 tw-whitespace-pre-line tw-pt-2">{{options.benefits_description}}</p>          
            </v-card-text>
        </v-card>
    </v-card>
</v-dialog>
</template>

<script>
import EventBus from '@/eventbus';
import firebase from 'firebase';
export default {
    props: ['artist', 'options', 'spotifyArtist', 'pageOptions'],
    data(){
        return{
            dialog: false,
        }
    },
    computed: {
        amount(){
            return 'R$'+parseFloat(this.options.subscriber_amount/100).toFixed(2).toString().replace(".", ",");
        }
    },
    methods: {
        subscribe(){
            if(Object.keys(this.currentUser).length){
                window.open('/checkout?artist='+this.artist.artista_id, '_blank');
            } else {
                this.activateLoginPopup();
            }
        },
        activateLoginPopup(){
            EventBus.$emit('activatePopup', {redirectTo: '/checkout?artist='+this.artist.artista_id});
        },
    },
    mounted(){
        EventBus.$on('activateSubscribePopup', e =>{
            this.dialog = true;
        });
    }
}
</script>

<style>
</style>